/**
 * @class FormatDataImport
 */
export default class FormatDataImport {
    /**
     * @param {String}  name
     * @param {String}  code
     * @param {Array}   files
     * @param {Array}   options
     * @param {Boolean} active      selected in dropdown list
     */
    constructor(name, code, files, options, active = false) {
        this._name = name;
        this._code = code;
        this._files = files;
        this._options = options;
        this._active = active;

        if (typeof this._name !== "string") {
            throw new Error("Invalid datatype of name");
        }
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get code() {
        return this._code;
    }

    /**
     * @param {String} code
     */
    set code(code) {
        this._code = code;
    }

    /**
     * @return {Array}
     */
    get files() {
        return this._files;
    }

    /**
     * @param {Array} files
     */
    set files(files) {
        this._files = files;
    }

    /**
     * @return {Array}
     */
    get options() {
        return this._options;
    }

    /**
     * @param {Array} options
     */
    set options(options) {
        this._options = options;
    }

    /**
     * @return {Boolean}
     */
    get active() {
        return this._active;
    }

    /**
     * @param {Boolean} active
     */
    set active(active) {
        this._active = active;
    }

    /**
     * @ return {Object}
     */
    clone() {
        return new FormatDataImport(this._name, this._code, this._files, this._options, this._active);
    }

    /**
     * Clones FormatDataImport object and updates active property.
     * @param {Boolean}  active
     * @return {Object}
     */
    updateActive = (active) => {
        let format = this.clone();
        format.active = active;

        return format;
    };

    /**
     * Clones FormatDataImport object and updates files property.
     * @param {Array}  files
     * @return {Object}
     */
    updateFiles = (files) => {
        let format = this.clone();
        format.files = files;

        return format;
    };

    /**
     * Clones FormatDataImport object and updates options property.
     * @param {Array}  options
     * @return {Object}
     */
    updateOptions = (options) => {
        let format = this.clone();
        format.options = options;

        return format;
    };

    /**
     * @return {String}
     */
    toString() {
        return "FormatDataImport (" + this._name + ")";
    }
}
